import BaseController from '../BaseController';
import Controller, { OnBeforeSubmit, OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import moment from 'moment/moment.js'
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { AbortableSubmitEvent, ChangeEvent, ClickEvent, MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BasicFile, FieldAPI, FileUploaderAPI, FormAPI, MapperAPI, SegmentedControlAPI } from '@philips-internal/oswald-ui-components';
import { ScheduleItem, SuggestionPeriodItem } from '../../interfaces/schedules-suggestions';
import { ISO_DATE_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils';
import { Value } from '@philips-internal/oswald-ui-core';
import { SuggestionCheckAvailableAliases } from '../../codegen';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { FileRuleUtils } from '../../utils/file-rules-utils';

const STATIC_PERIOD_DATASOURCE = [
  {
    id: 1,
    value: 'patient.morning'
  },
  {
    id: 2,
    value: 'patient.afternoon'
  },
  {
    id: 3,
    value: 'patient.night'
  }
];

interface RequestFormDate {
  observation: string;
  period: SuggestionPeriodItem[];
  uploadFiles?: BasicFile[];
}

@Controller({ fragment: 'suggestion-check-available' })
class SuggestionRequestModalController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject('segmented-control-period')
    periodSegmentedControl!: SegmentedControlAPI;

  @Inject('field-date')
    dateField!: FieldAPI;

  @Inject('field-obs')
    obsField!: FieldAPI;

  @Inject('field-period')
    periodField!: FieldAPI;

  @Inject('form-request')
    formRequest!: FormAPI;

  @Inject('mapper-avatar')
    avatarMapper!: MapperAPI;

  @Inject('file-uploader-0')
    fileUploderAPI!: FileUploaderAPI;

  private files: Array<BasicFile> = [];

  @OnMount({ target: 'layout-content' })
  onMount(event: MountEvent): void {
    if (event) {
      const context = this.context as unknown as Record<string, Value>;
      const suggestionItem = context.data as ScheduleItem;
      this.formRequest.setValue({
        selectedDate: moment(suggestionItem.date, ISO_DATE_FORMAT).format(ISO_DATE_FORMAT)
      })
      this.periodSegmentedControl.setData(STATIC_PERIOD_DATASOURCE);
      this.avatarMapper.setData(suggestionItem as unknown as Record<string, Value>);
    }
  }

  @OnMount(SuggestionCheckAvailableAliases.FILE_UPLOADER_0)
  async onMountFileUploader(event: MountEvent): Promise<void> {
    const fileUploaderApi = event.target as FileUploaderAPI;
    FileRuleUtils.validateFileUploaderRules(fileUploaderApi);
  }

  getPeriodChard(period: SuggestionPeriodItem): string {
    switch(period.id) {
      case 1: return 'M';
      case 2: return 'A';
      default: return 'E';
    }
  }

  @OnChange({ target: 'file-uploader-0' })
  handleFileUploadChange(event: ChangeEvent<Array<BasicFile>>): void {
    this.files = [...event.value];
    this.fileUploderAPI.setValue(this.files);
  }

  @OnBeforeSubmit({target: 'form-request'})
  handleFormSubmit(event: AbortableSubmitEvent): void {
    const data = event.record as unknown as RequestFormDate;
    const dataReturn = {
      attachedPrescheduleFiles: data.uploadFiles,
      observation: data.observation,
    };
    if (data.period.length > 0) {
      Object.assign(dataReturn, {period: this.getPeriodChard(data.period[0])})
    }
    this.submittableFragmentContext.submit(new SubmitEvent({ record: dataReturn }));
  }

  @OnClick({ target: 'button-confirm' })
  onConfirm(event: ClickEvent): void {
    if (event) {
      this.formRequest.submit();
    }
  }
}

export default SuggestionRequestModalController;
